var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-6 has-text-centered has-text-grey"},[_c('b-icon',{staticClass:"mb-2",attrs:{"icon":"crop-free","size":"is-medium"}}),_c('p',[_vm._v(_vm._s(_vm.message))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }